export function IsIOSMTags(obj) {
    if (typeof obj !== "object" || obj === null)
        return false;
    const maybe = obj;
    return (typeof maybe.readValue === "function" &&
        typeof maybe.readInt === "function" &&
        typeof maybe.readFloat === "function" &&
        typeof maybe.readBool === "function" &&
        typeof maybe.has === "function" &&
        typeof maybe.toJSON === "function");
}
//# sourceMappingURL=osm.interfaces.js.map